import React from "react";

import { ReactComponent as AuthenticationIcon } from "@common/assets/images/details-pane-icons/authentication-icon.svg";
import { ReactComponent as BrowserIcon } from "@common/assets/images/details-pane-icons/browser-icon.svg";
import { ReactComponent as DeviceIcon } from "@common/assets/images/details-pane-icons/device-icon.svg";
import { ReactComponent as LanguageIcon } from "@common/assets/images/details-pane-icons/language-icon.svg";
import { ReactComponent as NetworkIcon } from "@common/assets/images/details-pane-icons/network-icon.svg";
import { ReactComponent as OrientationIcon } from "@common/assets/images/details-pane-icons/orientation-icon.svg";
import { ReactComponent as OsIcon } from "@common/assets/images/details-pane-icons/os-icon.svg";
import { ReactComponent as ResolutionIcon } from "@common/assets/images/details-pane-icons/resolution-icon.svg";
import { ReactComponent as TimezoneIcon } from "@common/assets/images/details-pane-icons/timezone-icon.svg";
import { ReactComponent as MetadataIcon } from "@common/assets/images/shared-icons/metadata-icon.svg";

export interface MetricDimensionConfig {
  label: string;
  searchKey: string;
  icon: React.ReactNode;
}

export const METRIC_CONFIG: Record<string, MetricDimensionConfig> = {
  os_version: { label: "OS", icon: <OsIcon />, searchKey: "os_version" },
  device: { label: "Device", icon: <DeviceIcon />, searchKey: "device" },
  timezone: { label: "Timezone", icon: <TimezoneIcon />, searchKey: "timezone" },
  network_type: { label: "Network", icon: <NetworkIcon />, searchKey: "network_type" },
  auth_state: { label: "Authentication", icon: <AuthenticationIcon />, searchKey: "auth_state" },
  locale: { label: "Locale", icon: <LanguageIcon />, searchKey: "locale" },
  resolution: { label: "Resolution", icon: <ResolutionIcon />, searchKey: "resolution" },
  orientation: { label: "Orientation", icon: <OrientationIcon />, searchKey: "device_orientation" },
  browser: { label: "Browser", icon: <BrowserIcon />, searchKey: "browser_name" },
};

export function getMetricDimensionConfig(key: string): MetricDimensionConfig {
  return (
    METRIC_CONFIG[key] ?? {
      label: key,
      searchKey: key,
      icon: <MetadataIcon />,
    }
  );
}
